import { BulkAction } from 'labstep-web/components/Entity/Search/BulkActions';
import { Filter } from 'labstep-web/constants/filters';

export const bulkActions = [
  BulkAction.delete,
  BulkAction.tag,
  BulkAction.assign,
  BulkAction.transfer_ownership,
  BulkAction.share,
  BulkAction.add_to_folder,
  BulkAction.remove_from_folder,
  BulkAction.signature_request_create,
];

export const filters = [
  Filter.created_by,
  Filter.assigned_to,
  Filter.date_range,
  Filter.deleted,
  Filter.tag,
  Filter.signed,
  Filter.experiment_workflow_status_type,
  Filter.protocol,
  Filter.resource,
  Filter.molecule,
  Filter.device,
  Filter.metadata_experiment_workflow,
];

export const filtersTemplate = [
  Filter.created_by,
  Filter.date_range,
  Filter.deleted,
  Filter.tag,
  Filter.protocol,
  Filter.resource,
];
